import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const updateProfileMappingBody = (channelId: string, apis: any[]) => {
  const parsedObjs = apis.map((api) => {
    return {
      profileName: api.profileName,
      channelId: channelId,
      apiId: api.id,
      status: api.isSelected ? 1 : 2,
    }
  })
  console.log('updateProfileApiMappingRequestList parsedObjs', parsedObjs)
  return {
    updateProfileApiMappingRequestList: parsedObjs,
  }
}

const updatProfileApisStatusReq = (channelId: string, apis: any[], tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.updateProfileApisStatus,
    method: 'POST',
    config: sitConfig(tokens),
    body: updateProfileMappingBody(channelId, apis),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { updatProfileApisStatusReq }
